export interface Testimonial {
  /** Attribution line exactly as written in the sales letter */
  attribution: string
  name: string
  age: number
  location: string
  headline: string
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    attribution: 'Illustrative Student Pilot Feedback',
    name: 'Ryan Mitchell',
    age: 24,
    location: 'Austin, Texas, United States',
    headline: 'Aircraft systems are much easier to understand visually.',
    quote:
      'Reading about aircraft components is one thing, but seeing how the different systems connect makes the information much easier to organize and understand.',
  },
  {
    attribution: 'Illustrative Private Pilot Student Feedback',
    name: 'Sophie Clarke',
    age: 31,
    location: 'Bristol, United Kingdom',
    headline: 'The cockpit instrument references are incredibly useful.',
    quote:
      'Having instruments organized into visual identification cards makes reviewing their functions and indications much more convenient than searching through different manuals.',
  },
  {
    attribution: 'Illustrative Aviation Student Feedback',
    name: 'Liam Tremblay',
    age: 21,
    location: 'Calgary, Alberta, Canada',
    headline: 'A much more organized way to study aviation.',
    quote:
      'Aerodynamics, navigation, weather, aircraft systems, and flight procedures are all connected. Having these subjects organized into visual modules makes studying feel more structured.',
  },
  {
    attribution: 'Illustrative PPL Candidate Feedback',
    name: "James O'Connor",
    age: 38,
    location: 'Brisbane, Queensland, Australia',
    headline: 'The VFR planning workbook adds practical value.',
    quote:
      'Working through navigation calculations, planning worksheets, and flight preparation examples helps connect theoretical knowledge with the planning process.',
  },
  {
    attribution: 'Illustrative Aviation Enthusiast Feedback',
    name: 'David Reynolds',
    age: 47,
    location: 'Denver, Colorado, United States',
    headline: 'A visual aviation resource worth revisiting.',
    quote:
      'The aircraft diagrams, instrument references, flight planning exercises, and study organization tools make this a useful companion for reviewing private pilot knowledge.',
  },
]
